// extracted by mini-css-extract-plugin
module.exports = {"party":"political-party-module--party--2xHzl","header":"political-party-module--header--3eYzn"};